import React from "react";
import styles from "./QuarryFinanceCard.module.scss";
import { Col, Row } from "antd";
import { getFinanceDetails } from "./constants";
import { QuarryDetailsType } from "../../../../Types/quarryDatabaseTypes";

interface QuarryFinanceCardProps {
  quarryDetails: QuarryDetailsType;
}

const QuarryFinanceCard = ({ quarryDetails }: QuarryFinanceCardProps) => {
  return (
    <div className={styles.detailsCard}>
      <Row gutter={[10, 24]}>
        {getFinanceDetails(quarryDetails)?.map((item) => (
          <Col span={8}>
            <div className={styles.itemWrapper}>
              <div className={styles.valueText}>{item?.value}</div>
              <div className={styles.labelText}>{item.label}</div>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default QuarryFinanceCard;
